import React, { useState } from 'react';
import OtpInput from 'react-otp-input';
import { FormattedMessage, injectIntl } from 'react-intl';
import { TextStyle, Heading, Button } from '@superops/ui-design-system';

const TFAContainer = (props) => {
  const [code, setCode] = useState('');

  const handleChange = (val) => {
    setCode(val);
  };

  const handleSubmission = () => {
    if (code.length === 6) {
      props.handleTFACode(code);
    }
  };

  return (
    <>
      <div className="flex col g10 astart">
        <TextStyle variation="subdued">
          <FormattedMessage id="login.tfa.helpText" />
        </TextStyle>
        <Heading>
          <FormattedMessage id="login.tfa.authCode" />
        </Heading>
        <OtpInput
          value={code}
          onChange={handleChange}
          numInputs={6}
          separator={<pre> </pre>}
          inputStyle={{ height: '3em', width: '3em' }}
          isInputNum
          shouldAutoFocus
        />
        <Button primary onClick={handleSubmission}>
          <FormattedMessage id="common.login" />
        </Button>
      </div>
    </>
  );
};

export default injectIntl(TFAContainer);
